import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=64a73a74&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/header.css?vue&type=style&index=0&id=64a73a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a73a74",
  null
  
)

export default component.exports